import React from "react";
import { Box } from "@mui/material";
import Img2 from "../../assets/images/dashboard/img2.jpg";
import Heading from "../../assets/images/dashboard/page2/heading2.png";
import Subheading from "../../assets/images/dashboard/page2/subheader2.png";
import Readmore from "../../assets/images/dashboard/page2/readmore.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const Page2 = () => {
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        backgroundImage: `url(${Img2})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "end",
        justifyContent: "flex-end",
      }}
    >
      <Box
        sx={{
          width: { xs: "80%", md: "40%" },
          marginBottom: { xs: "80px", md: "80px" },
          marginRight: "50px",
        }}
      >
        <img
          style={{
            height: "auto",
            width: "100%",
            marginTop: "30px",
          }}
          src={Heading}
          alt="Heading"
        />
        <img
          style={{
            height: "auto",
            width: "100%",
            marginTop: "30px",
          }}
          src={Subheading}
          alt="Subheading"
        />
        <Box
          onClick={() => navigate("../../services")}
          sx={{ cursor: "pointer" }}
        >
          <img
            style={{
              height: "auto",
              width: isTablet ? "50%" : "25%",
              marginTop: "30px",
            }}
            src={Readmore}
            alt="Readmore"
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Page2;
